/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocIcon16Solid = forwardRef('DocIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 1H4.5A2.5 2.5 0 0 0 2 3.5v9A2.5 2.5 0 0 0 4.5 15h6a2.5 2.5 0 0 0 2.5-2.5V6H9.5A1.5 1.5 0 0 1 8 4.5V1Z" }),
        React.createElement("path", { d: "M13 5v-.01L9.01 1H9v3.5a.5.5 0 0 0 .5.5H13Z" })));
});
